<div class="apply-one-grid apply-one-style">
  @if (contractsByBrand) {
    <div class="site-width">
      <div class="container-fluid pt-1 pt-md-3 pb-2 pb-md-3">
        <h1>{{ 'ecm.selector.usage.title' | translate }}</h1>
        <!-- equipments list -->
        @if (contractsByBrand && contractsByBrand.size > 0) {
          @for (brand of brandsAvailable; track brand; let isFirst = $first; let isLast = $last) {
            <div
              [ngClass]="{'mb-2 mb-md-3': contractsByBrand.size > 1 && !isLast}"
              >
              <!-- other universe title, when multiple brand are available -->
              @if (contractsByBrand.size > 1 && !isFirst) {
                <h2 class="h3">
                  {{ 'ecm.selector.universe.' + brand + '.title' | translate }}
                </h2>
              }
              <ul class="items-list row">
                @for (contract of contractsByBrand.get(brand); track contract) {
                  @for (usage of contract.usages; track usage) {
                    <li class="col-12 col-md-6">
                      <ecm-mat-item-list
                        [itemIcon]="isFirst ? itemsRender.get(contract.cid + '_' + usage.usageCode).icon : reverseBrandLogoUrl"
                        [itemLabel]="itemsRender.get(contract.cid + '_' + usage.usageCode).label"
                        [itemText]="itemsRender.get(contract.cid + '_' + usage.usageCode).description"
                        [itemPath]="getReturnUrl(contract.cid, usage.usageCode)"
                        [e2e]="contract.cid + '_' + usage.usageCode"
                        (materialItemListEvent)="redirectToReturnUrl(contract, usage.usageCode)"
                      ></ecm-mat-item-list>
                    </li>
                  }
                }
              </ul>
            </div>
          }
        } @else {
          <div class="text-mw">
            <ecm-mat-alert
              [style]="'warning'"
              [title]="'ecm.selector.error.unavailable.title' | translate"
            ></ecm-mat-alert>
          </div>
        }
        <!-- no usage / contract available -->
      </div>
    </div>
    <!-- rebound links -->
    @if (!isWebviewContext) {
      <ecm-selector-rebound-links [universe]="universe"></ecm-selector-rebound-links>
    }
  } @else {
    <div class="py-5">
      <ecm-mat-spinner></ecm-mat-spinner>
    </div>
  }
</div>

<!-- usage selector -->

<!-- loader -->
